/* v-tooltip="metin" (.hover / .focus / .click tetikleyicileri, .top / .bottom / .left / .right
   yerleşimi; varsayılan hover+focus ve top). Bootstrap 5 tooltip DOM'unu üretir
   (div.tooltip.bs-tooltip-<top|bottom|start|end> > .tooltip-arrow + .tooltip-inner), Bootstrap JS ve
   Popper kullanmaz. Öğe document.body'ye eklenir (z-index 1080, modalların üstünde), sığmazsa karşı
   tarafa döner ve yatayda görünüm alanına sıkıştırılır. Ok payı (BS4'te .tooltip'in .4rem dolgusu)
   BS5'te kutunun dışındadır; konum hesabı bu payı ekler, yer BS4'teki gibi kalır. */

const STATE = '__estTooltip';
const PLACEMENTS = ['top', 'bottom', 'left', 'right'];
const OPPOSITE = { top: 'bottom', bottom: 'top', left: 'right', right: 'left' };
const BS_PLACEMENT = { top: 'top', bottom: 'bottom', left: 'start', right: 'end' };
const DELAY = 50; // bootstrap-vue varsayılanı
const FADE = 150; // BS4 .fade geçişi
const PADDING = 5;
let uid = 0;

function placementOf(modifiers) {
    return PLACEMENTS.find(placement => modifiers[placement]) || 'top';
}

function triggersOf(modifiers) {
    const triggers = ['hover', 'focus', 'click'].filter(trigger => modifiers[trigger]);
    return triggers.length ? triggers : ['hover', 'focus'];
}

function titleOf(value) {
    if (value === null || value === undefined) return '';
    return typeof value === 'string' ? value : String(value);
}

function fitsAt(rect, width, height, placement, gap) {
    if (placement === 'top' || placement === 'bottom') height += 2 * gap;
    else width += 2 * gap;
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight;
    return {
        top: rect.top - height >= 0,
        bottom: rect.bottom + height <= viewportHeight,
        left: rect.left - width >= 0,
        right: rect.right + width <= viewportWidth
    }[placement];
}

/* Ok payı: BS4'te `.bs-tooltip-*`'ın ok yönündeki dolgusu (.4rem); BS5'te ok kutunun dışında aynı ölçüde. */
function arrowGap(tip, placement) {
    const style = window.getComputedStyle(tip.firstChild);
    return parseFloat(placement === 'top' || placement === 'bottom' ? style.height : style.width) || 0;
}

function computePosition(rect, tip, placement, gap) {
    const width = tip.offsetWidth;
    const height = tip.offsetHeight;
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight;
    let x;
    let y;
    if (placement === 'top' || placement === 'bottom') {
        x = rect.left + rect.width / 2 - width / 2;
        x = Math.max(PADDING, Math.min(x, viewportWidth - width - PADDING));
        y = placement === 'top' ? rect.top - height - 2 * gap : rect.bottom;
    } else {
        y = rect.top + rect.height / 2 - height / 2;
        y = Math.max(PADDING, Math.min(y, viewportHeight - height - PADDING));
        x = placement === 'left' ? rect.left - width - 2 * gap : rect.right;
    }
    return { x, y };
}

function setPlacementClass(state, placement) {
    state.tip.className = `tooltip bs-tooltip-${BS_PLACEMENT[placement]} fade${state.visible ? ' show' : ''}`;
}

function place(el) {
    const state = el[STATE];
    const tip = state && state.tip;
    if (!tip) return;

    const rect = el.getBoundingClientRect();
    let actual = state.placement;
    setPlacementClass(state, actual);
    if (!fitsAt(rect, tip.offsetWidth, tip.offsetHeight, actual, arrowGap(tip, actual))) {
        const opposite = OPPOSITE[actual];
        setPlacementClass(state, opposite);
        if (fitsAt(rect, tip.offsetWidth, tip.offsetHeight, opposite, arrowGap(tip, opposite))) actual = opposite;
        else setPlacementClass(state, actual);
    }
    // Konum BS4 kutusuyla (ok dolgusu dahil) hesaplanıp Popper 1 gibi yuvarlanır, sonra dolgu kadar kaydırılır.
    const gap = arrowGap(tip, actual);
    const { x, y } = computePosition(rect, tip, actual, gap);
    // Popper 1 yuvarlaması: yatayda genişlik pariteleri aynıysa round, değilse floor; dikeyde floor.
    const vertical = actual === 'top' || actual === 'bottom';
    const sameParity = Math.round(rect.width) % 2 === Math.round(tip.offsetWidth + (vertical ? 0 : 2 * gap)) % 2;
    const px = (sameParity ? Math.round : Math.floor)(x + window.pageXOffset) + (vertical ? 0 : gap);
    const py = Math.floor(y + window.pageYOffset) + (vertical ? gap : 0);
    tip.style.transform = `translate3d(${px}px, ${py}px, 0px)`;

    // Popper 1 arrow modifier'ı gibi okun dış ölçüsüyle (margin dahil) ortalanır.
    const arrow = tip.firstChild;
    const arrowStyle = window.getComputedStyle(arrow);
    if (actual === 'top' || actual === 'bottom') {
        const arrowWidth = arrow.offsetWidth + (parseFloat(arrowStyle.marginLeft) || 0) + (parseFloat(arrowStyle.marginRight) || 0);
        const left = rect.left + rect.width / 2 - x - arrowWidth / 2;
        arrow.style.left = `${Math.round(Math.max(0, Math.min(left, tip.offsetWidth - arrowWidth)))}px`;
        arrow.style.top = '';
    } else {
        const arrowHeight = arrow.offsetHeight + (parseFloat(arrowStyle.marginTop) || 0) + (parseFloat(arrowStyle.marginBottom) || 0);
        const top = rect.top + rect.height / 2 - y - arrowHeight / 2;
        arrow.style.top = `${Math.round(Math.max(0, Math.min(top, tip.offsetHeight - arrowHeight)))}px`;
        arrow.style.left = '';
    }
}

function clearTimers(state) {
    clearTimeout(state.showTimer);
    clearTimeout(state.hideTimer);
    clearTimeout(state.removeTimer);
    state.showTimer = state.hideTimer = state.removeTimer = null;
}

function removeTip(el) {
    const state = el[STATE];
    if (!state || !state.tip) return;
    if (state.tip.parentNode) state.tip.parentNode.removeChild(state.tip);
    state.tip = null;
    state.visible = false;
    el.removeAttribute('aria-describedby');
}

function createTip(el) {
    const state = el[STATE];
    if (!state.title) return;
    if (!state.tip) {
        uid += 1;
        const tip = document.createElement('div');
        tip.id = `est_tooltip_${uid}`;
        tip.setAttribute('role', 'tooltip');
        tip.setAttribute('tabindex', '-1');
        tip.style.position = 'absolute';
        tip.style.top = '0px';
        tip.style.left = '0px';
        tip.style.willChange = 'transform';
        const arrow = document.createElement('div');
        arrow.className = 'tooltip-arrow';
        arrow.style.position = 'absolute';
        const inner = document.createElement('div');
        inner.className = 'tooltip-inner';
        // Metindeki satır sonu korunur (ör. eksik bilgi uyarısının madde listesi tek satıra yığılıyordu).
        inner.style.whiteSpace = 'pre-line';
        tip.appendChild(arrow);
        tip.appendChild(inner);
        state.tip = tip;
    }
    setText(state);
    state.visible = false;
    document.body.appendChild(state.tip);
    place(el);
    el.setAttribute('aria-describedby', state.tip.id);
    window.requestAnimationFrame(() => {
        if (!state.tip) return;
        state.visible = true;
        state.tip.classList.add('show');
    });
}

function show(el) {
    const state = el[STATE];
    if (!state || !state.title) return;
    clearTimers(state);
    state.showTimer = setTimeout(() => createTip(el), DELAY);
}

function hide(el) {
    const state = el[STATE];
    if (!state) return;
    clearTimers(state);
    state.hideTimer = setTimeout(() => {
        if (!state.tip) return;
        state.visible = false;
        state.tip.classList.remove('show');
        state.removeTimer = setTimeout(() => removeTip(el), FADE);
    }, DELAY);
}

function toggle(el) {
    const state = el[STATE];
    if (state && state.tip && state.visible) hide(el);
    else show(el);
}

// Satırlı metin (madde listesi) ortalanınca okunmuyordu; tek satır ortalı kalır.
function setText(state) {
    const inner = state.tip.lastChild;
    inner.textContent = state.title;
    inner.style.textAlign = state.title.includes('\n') ? 'left' : '';
}

function bind(el, binding) {
    const state = {
        title: titleOf(binding.value),
        placement: placementOf(binding.modifiers || {}),
        tip: null,
        visible: false,
        showTimer: null,
        hideTimer: null,
        removeTimer: null,
        listeners: []
    };
    el[STATE] = state;

    const listen = (event, handler) => {
        el.addEventListener(event, handler);
        state.listeners.push([event, handler]);
    };
    const triggers = triggersOf(binding.modifiers || {});
    if (triggers.includes('hover')) {
        listen('mouseenter', () => show(el));
        listen('mouseleave', () => hide(el));
    }
    if (triggers.includes('focus')) {
        listen('focusin', () => show(el));
        listen('focusout', () => hide(el));
    }
    if (triggers.includes('click')) listen('click', () => toggle(el));
}

function update(el, binding) {
    const state = el[STATE];
    if (!state) return;
    state.title = titleOf(binding.value);
    state.placement = placementOf(binding.modifiers || {});
    if (!state.tip) return;
    if (!state.title) {
        removeTip(el);
        return;
    }
    setText(state);
    place(el);
}

function unbind(el) {
    const state = el[STATE];
    if (!state) return;
    clearTimers(state);
    state.listeners.forEach(([event, handler]) => el.removeEventListener(event, handler));
    removeTip(el);
    delete el[STATE];
}

export default {
    beforeMount: bind,
    updated: update,
    unmounted: unbind
};
